var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_vm._v(" There was a problem loading this page. Please try reloading it. ")])}
var staticRenderFns = []

export { render, staticRenderFns }